/**
 * Native port of the v1 `touchpointActivator` service
 * (account-v1/src/components/touchpoints/services/touchpointActivator.js).
 * WS5 #10 Stage B B4a: replaces the `$injector.get('touchpointActivator')` grab
 * in ft-touchpoint-container (`showActivate()` → `canActivate(touchpointType)`).
 *
 * Verbatim: the same `canActivateTouchpoints` membership list (NOTE: distinct from
 * — and wider than — `Touchpoint.canActivate`'s list in touchpoint.js; this is the
 * one the container's activate switch is gated on). Pure function → a plain exported
 * object so the call site keeps the v1 shape (`touchpointActivator.canActivate(...)`).
 */
const canActivateTouchpoints = [
  'followup', 'invitation-email', 'finalistsEmail', 'reminderEmail', 'activityEmail',
  'winnerEmail', 'homepageEmail', 'confirmation', 'quote', 'contestPage', 'list', 'homepage', 'mobile',
  'pre-arrival-email', 'confirmation-email-image', 'poststay-email-image', 'reminder-emails', 'reengagement-emails', 'photo-river', 'certificate-reminder-email',
];

export const touchpointActivator = {
  /** Returns true if touchpoint can be activated/deactivated using the app. */
  canActivate(touchpointType: string): boolean {
    return canActivateTouchpoints.indexOf(touchpointType) > -1;
  },
};
